'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isApple = function isApple(platform) {
  return platform.indexOf('iPhone') !== -1 || platform.indexOf('iPad') !== -1 || platform.indexOf('iPod') !== -1;
};

var BusinessContact = function (_React$Component) {
  _inherits(BusinessContact, _React$Component);

  function BusinessContact() {
    _classCallCheck(this, BusinessContact);

    var _this = _possibleConstructorReturn(this, (BusinessContact.__proto__ || Object.getPrototypeOf(BusinessContact)).call(this));

    _this.state = { addressHref: '' };
    return _this;
  }

  _createClass(BusinessContact, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ addressHref: this.setNativeMapsAppLink(navigator.platform) });
    }
  }, {
    key: 'setNativeMapsAppLink',
    value: function setNativeMapsAppLink(platform) {
      // TODO(https://trello.com/c/SmVfzMIG) Use regex for parsing address
      var tokCompInfo = this.props.companyInfo.address.split(' ').map(function (token, index) {
        return index > 0 ? '+' + token : token;
      }).map(function (token, index) {
        return index === 3 ? token + ',' : token;
      });
      var addressUrl = '' + tokCompInfo.slice(0, 3).reduce(function (a, b) {
        return a + b;
      }) + tokCompInfo[3] + tokCompInfo[4] + tokCompInfo[5];
      if (isApple(platform)) {
        return 'maps://maps.google.com/?q=' + addressUrl;
      }
      return 'https://www.google.com/maps/search/?api=1&query=' + addressUrl;
    }
  }, {
    key: 'createContactActions',
    value: function createContactActions() {
      var companyInfo = this.props.companyInfo;

      return [{
        text: companyInfo.address,
        href: this.state.addressHref,
        iconName: 'marker',
        extraProps: { target: '_new' }
      }, {
        text: companyInfo.phone,
        href: 'tel:+' + companyInfo.phone,
        iconName: 'phone',
        extraProps: {}
      }, {
        text: companyInfo.email,
        href: 'mailto:' + companyInfo.email,
        iconName: 'mail',
        extraProps: {}
      }];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          withIcons = _props.withIcons;

      var actions = this.createContactActions();
      return _react2.default.createElement(
        'span',
        { className: className },
        actions.map(function (action, index) {
          return _react2.default.createElement(
            'span',
            { key: action.iconName },
            _react2.default.createElement(
              'a',
              _extends({ href: action.href }, action.extraProps, { style: { color: 'inherit' } }),
              action.text,
              action.text && withIcons && _react2.default.createElement(_semanticUiReact.Icon, { style: { paddingLeft: '0.5em' }, name: action.iconName })
            ),
            index !== actions.length - 1 && action.text && _react2.default.createElement('br', null)
          );
        })
      );
    }
  }]);

  return BusinessContact;
}(_react2.default.Component);

exports.default = BusinessContact;


BusinessContact.propTypes = {
  companyInfo: _propTypes2.default.shape({
    address: _propTypes2.default.string,
    phone: _propTypes2.default.string,
    email: _propTypes2.default.string
  }).isRequired,
  className: _propTypes2.default.string,
  withIcons: _propTypes2.default.bool
};

BusinessContact.defaultProps = {
  className: '',
  withIcons: true
};


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-components/build/components/molecules/BusinessContact/BusinessContact.js
// module id = 472
// module chunks = 168707334958949